<template>
  <div class="d-flex p-20 justify-content-center">

    <div class="welcome-card">
      <div>
        <img
            alt="Landing image"
            class="img-fluid"
            src="./../assets/images/landing-img@2x.png"
            srcset="
                    ./../assets/images/landing-img@1x.png 1x,
                    ./../assets/images/landing-img@2x.png 2x,
                    ./../assets/images/landing-img@3x.png 3x,
                    ./../assets/images/landing-img@4x.png 4x
                "
        />
      </div>
      <div class="welcome-card-item">
        <div>
          <h1>{{ 'Welcome to AI Magic Editor Alpha!' | trans }}</h1>
          <p>{{ 'Prepare to embark on a journey of image transformation like never before. With AI-powered inpainting, you now have the ability to modify your images with unparalleled precision and creativity.' | trans}}</p>
        </div>
      </div>
      <div class="welcome-card-item">
        <div class="welcome-card-content d-flex justify-content-space-between">
          <router-link
              v-slot="{ href, route, navigate, isActive, isExactActive }"
              :to="{ name: 'StageInpaint', params: { uuid: id, activeStageId: activeStage.id } }"
          >
            <div
                :class="[isActive && 'active', isExactActive && 'active']"
                class="btn-info w-100 btn-lg cursor-pointer d-flex gap-10 align-items-center"
                @click="navigate"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 20 20"><path fill="currentColor" d="M14 7.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0a.5.5 0 0 0 1 0M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.003c-.341.016-.68.092-1 .229V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8.826a.2.2 0 0 0 .34.142l.807-.796l-.002-.003l1.048-1.03l.206-.202l2.55-2.505a1.5 1.5 0 0 1 2.102 0l1.745 1.714l-.707.708l-1.739-1.709a.5.5 0 0 0-.7 0l-2.756 2.707l-1.851 1.828c-.758.748-2.043.21-2.043-.854zm.4 11.035c.369.184.83.335 1.217.25c.251-.056.577-.193.943-.347c.885-.373 2.003-.843 2.862-.497c.637.256.584.981.405 1.33c-.035.066-.008.16.065.177a4.6 4.6 0 0 0 1.112.088a.917.917 0 0 1 .023-.14l.375-1.498a2.18 2.18 0 0 1 .578-1.02l4.83-4.83a1.87 1.87 0 1 1 2.644 2.645l-4.83 4.829a2.197 2.197 0 0 1-1.02.578l-1.222.305c-1.121.328-2.794.222-3.313-.183c-.449-.35-.467-.887-.316-1.244c.034-.08-.026-.183-.111-.17c-.495.07-.9.25-1.3.427c-.585.26-1.156.513-1.976.411c-.711-.088-1.107-.459-1.325-.825c-.122-.204.147-.392.36-.286"/></svg>

              {{ 'Start with Inpainting' | trans }} <i class="far fa-arrow-right"></i>
            </div>
          </router-link>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../mixins/store.mixin'
import currentJob from './../mixins/current_job.mixin'

export default {
  name: "Welcome",
  props: {},
  components: {},
  mixins: [
    store,
      currentJob
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
.welcome-card {
  width: 685px;
  background: #424242;
  color: #E8EAED;
}

.welcome-card-item {
  border-bottom: 1px solid #595959;
  padding: 20px;
  display: flex;
  gap: 20px;

  // .welcome-card-icon {
  // }

  // .welcome-card-content {
  // }

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #E8EAED;
  }

  h2 {
    font-size: 17.5px;
    font-weight: 600;
    margin: 0 0 10px 0;
    color: #E8EAED;
  }

  p {
    font-size: 14px;
    font-weight: 400;
  }
}

</style>
